module.exports = __webpack_public_path__ + "static/media/spider-background-small.1c588220.svg";